import { Link } from "react-router-dom";

const stats = [
  { value: "10+", label: "收录影片" },
  { value: "5+", label: "热播剧集" },
  { value: "全类型", label: "题材覆盖" },
  { value: "每日", label: "资讯更新" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 md:px-6">
      <div className="grid grid-cols-1 items-center gap-6 rounded-lg border border-background-200 bg-background-50 p-6 md:grid-cols-2 md:p-10">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于麻豆精品
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            麻豆精品是一个面向电影与电视剧爱好者的综合影视内容平台。我们汇集最新影片与热播剧集的
            <strong className="mx-1 font-semibold text-foreground-900">全集索引</strong>
            与
            <strong className="mx-1 font-semibold text-foreground-900">专业影视资讯</strong>
            ，通过清晰的分类、便捷的搜索与多维筛选，帮助你更快找到想看的作品。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            无论你是想追一部刚上线的新剧，还是想了解行业最新动态，都能在这里轻松浏览、收藏与分享。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line" aria-hidden="true"></i>
              开始探索
            </Link>
            <Link
              to="/about"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-200"
            >
              了解更多
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-100 p-5 text-center md:p-6"
            >
              <p className="font-heading text-2xl font-extrabold text-primary-600 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}